<style>

</style>
<template>
<img v-if="icon" :src="src"/>
<svg class="svg-icon" v-else>
  <use :xlink:href="'#' + name"></use>
</svg>
</template>
<script>
export default {
  props: ['name', 'icon'],
  computed: {
    src() {
      if (!this.icon) return
      return require(`../assets/icons/${this.icon}.svg`)
    }
  }
}

</script>
